module.exports = __webpack_public_path__ + "static/media/LibreBaskerville-Regular.228126bc.ttf";